module.exports = __webpack_public_path__ + "media/pdf_missing/skuter@3x-92c4afa3.svg";